<!-- Suggested prompts (PCSA-13159). Reuses the shared <ui-button> with
     rank="alt-secondary" (the design token for the navy outlined pill) so the
     chips stay consistent with the rest of the app — keyboard- and
     screen-reader-accessible for free (AC 13). The first chip
     ("How does this work?") is answered as a conversation turn — the host appends
     the label as a user message plus the explainer as an agent response — and is
     offered on a NEW conversation ONLY (`showHowItWorks`, design review 08/19).
     The rest pre-fill the input and stay for the whole conversation.

     That first chip wears the blue→purple gradient AT REST and reverts to the
     stock outlined pill on hover; the others are outlined pills throughout
     (design review 08/11). The gradient used to be every chip's hover state,
     which meant the one chip worth highlighting looked identical to the rest
     until the pointer landed on it — and never highlighted at all on touch. -->
<!-- Each chip is wrapped in an <li> so the list semantics live on the list
     structure, not on the button (a `role="listitem"` on a <button> conflicts
     with button semantics for assistive tech).

     These are the one Orbi control that KEEPS `[minWidth]="0"`. The 08/11 review
     put every CARD CTA on ui-button's 128px floor, but a chip is not a CTA: this
     is a wrapping flow of label-width pills, and a 128px floor would pad the
     short ones out to a uniform block and fit fewer per line — the opposite of
     what the Figma draws. -->

<ul class="orbi-prompts" [class.orbi-prompts--start]="align === 'start'" aria-label="Suggested prompts">
  <!-- `*ngIf`, not `[hidden]`: this chip has nothing random about it, so nothing is
       lost by destroying it, and it has to leave the LAYOUT — `[hidden]` would be
       overridden by `.orbi-prompts__item { display: flex }` and leave the pill on
       screen anyway, and even scoped correctly it would strand an empty 8px gap at
       the head of the stack. -->
  <li *ngIf="showHowItWorks" class="orbi-prompts__item">
    <!-- `--featured` is what carries the resting gradient. A modifier rather than
         a `:first-child` rule, because the gradient belongs to THIS chip's role
         (the explainer, the recommended way in) and not to whatever happens to
         sort first. -->
    <ui-button
      class="orbi-prompts__chip orbi-prompts__chip--featured"
      rank="alt-secondary"
      size="small"
      [buttonText]="howItWorksLabel"
      [minWidth]="0"
      (handleClick)="onHowItWorks()"
    ></ui-button>
  </li>

  <li *ngFor="let prompt of prompts; trackBy: trackByLabel" class="orbi-prompts__item">
    <ui-button
      class="orbi-prompts__chip"
      rank="alt-secondary"
      size="small"
      [buttonText]="prompt.shortPrompt"
      [attr.aria-label]="prompt.fullPrompt"
      [minWidth]="0"
      (handleClick)="onSelect(prompt)"
    ></ui-button>
  </li>
</ul>
